<app-page-title
	title="Enviar lista"
	subtitle="Bem-vindo ao Bolão {{year}}"
	breadcrumb="Cadastrar"
	[loading]="pageLoading || loading"
	/>

<section class="page-section container">

	<app-list-form *ngIf="open" (submit)="register($event)" [loading]="loading">
		<div class="welcome w-full">Você está se cadastrando no <br/>Bolão Pé na Cova {{year}}</div>
		<div class="remember">
			Lembrando:
			<ul>
				<li>A lista só começa a ser válida <em>um mês após o envio</em>.</li>
				<li>Após enviada a lista <em>não poderá ser modificada ou excluída</em>.</li>
				<li>Um nome para cada campo de apostas.</li>
				<li>Não esqueça de conferir o <a (click)="goRules()">regulamento</a>.</li>
				<li>Certifique-se que a aposta é <a (click)="goCebs()">uma celebridade válida</a>.</li>
			</ul>
		</div>
	</app-list-form>

	<div class="" *ngIf="!open && !pageLoading">
		<h2> INSCRIÇÕES FECHADAS! </h2>
		<p>
			EM BREVE NOVIDADES.
		</p>
	</div>

</section>
